import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';

import * as analytics from 'utilities/analytics';

import CustomBrandingImg from 'img/workspace-onboarding/custom-branding.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { MANAGE_WORKSPACE } from '../../../../../../constants/routes';
import { CUSTOMIZE_BRANDING_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360006122198';

const CustomizeBrandingCard = ({ cardConfig }) => {
  const centerpiece = <img src={CustomBrandingImg} />;
  const primaryAction = (
    <Button
      onClick={() => {
        analytics.track(
          DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED,
          {
            type: 'primary',
            card: CUSTOMIZE_BRANDING_CARD_KEY,
          },
          () => {
            window.location.href = `${MANAGE_WORKSPACE}#appearance`;
          }
        );
      }}
    >
      Go to settings
    </Button>
  );

  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: CUSTOMIZE_BRANDING_CARD_KEY,
        });
        window.open(SUPPORT_ARTICLE_LINK);
      }}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );

  return (
    <DashboardOnboardingCard
      cardKey={CUSTOMIZE_BRANDING_CARD_KEY}
      cardConfig={cardConfig}
      heading="Customize the video share page"
      description="Add a logo and change the color to match your brand."
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="Looking good! You have customized the video share page."
    />
  );
};

export default CustomizeBrandingCard;
